import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getRuntimeConfiguration } from "../api/runtimeConfiguration.api";
import type { RuntimeConfiguration } from "../types/runtimeConfiguration.types";

export function useGetRuntimeConfiguration() {
  const [data, setData] = useState<RuntimeConfiguration | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run, loading } = useLatestRequest();

  const refetch = useCallback(async () => {
    setError(null);
    try {
      const result = await run((signal) => getRuntimeConfiguration(signal));
      if (result) setData(result);
    } catch (requestError: unknown) {
      setData(null);
      setError(getApiErrorMessage(requestError, "Failed to load runtime configuration"));
    }
  }, [run]);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { data, error, loading, refetch };
}
